//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "S2InputSelect",
  components: {
    BaseTransitionSimple: () =>
      import("../../common/transitions/BaseTransitionSimple.vue"),
    InputSelectButton: () => import("./InputSelectButton.vue"),
    InputSelectOptions: () => import("./InputSelectOptions.vue"),
    MessageError: () => import("../message/MessageError.vue"),
  },
  props: {
    disabled: Boolean,
    error: Boolean,
    errorMessage: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    selectedOption() {
      const option =
        this.options.find((option) => option.id === this.value) || {};
      return option;
    },
  },
  methods: {
    emitValue(id) {
      if (!this.disabled) {
        this.$emit("input", id);
        this.setActive(false);
      }
    },
    setActive(active = false) {
      if (!this.disabled) this.active = active;
    },
  },
};
